import { create } from 'zustand';
import type { ItemCondition, UploadedPhoto } from '@/types/domain';

export interface AuctionDraft {
  // Шаг 1: фото (загружены в стораж, с URL-ами)
  photos: UploadedPhoto[];

  // Шаг 2: основное
  title: string;
  description: string;
  condition: ItemCondition;
  city: string;

  // Шаг 3: цены и сроки
  start_price: number;     // копейки
  min_step: number;
  buy_now_price: number | null;
  duration_minutes: number;

  // Шаг 4: теги
  tags: string[];
}

const initialDraft: AuctionDraft = {
  photos: [],
  title: '',
  description: '',
  condition: 'good',
  city: '',
  start_price: 100_00,        // 100 ₽
  min_step: 10_00,            // 10 ₽
  buy_now_price: null,
  duration_minutes: 24 * 60,        // 1 день
  tags: [],
};

interface DraftStore {
  draft: AuctionDraft;
  update: (patch: Partial<AuctionDraft>) => void;
  reset: () => void;
}

export const useDraftStore = create<DraftStore>((set) => ({
  draft: initialDraft,
  update: (patch) => set((s) => ({ draft: { ...s.draft, ...patch } })),
  reset: () => set({ draft: initialDraft }),
}));